import axios from 'axios'
import AssessmentForm from '../entity/assignment/assessment-form.entity'
import AssessmentResponse from '../entity/emp-assessment-response';
import EmployeeAssessmentResult from '../entity/employee-assessment-result';
import AssessmentFilter from '../entity/assessment-filter.entity';
import Assessment from '../entity/assessment';
import AssessmentSimulationSimple from '../entity/assessment-simulation-list.entity';

export default class AssessmentService {
  public static async getFormTemplateByEmployeeId(employeeId: string): Promise<Assessment> {
    const { data } = await axios.get(`/api/assessment/form-template/${employeeId}`);
    return new Assessment(data);
  }

  public static async getFormTemplateByAssignmentId(assignmentId: string): Promise<AssessmentForm> {
    const { data } = await axios.get(`/api/assessment/form-template/assignment/${assignmentId}`);
    return new AssessmentForm(data);
  }

  public static create(employeeId: string, assessmentResponse: AssessmentResponse): Promise<void> {
    return axios.post(`/api/assessment/${employeeId}`, assessmentResponse);
  }

  public static async createByAssignmentId(
    assignmentId: string,
    assessmentResponse: AssessmentResponse,
  ): Promise<void> {
    return axios.post(`/api/assessment/assignment/${assignmentId}`, assessmentResponse);
  }

  public static async getResultByEmployeeId(employeeId: string): Promise<EmployeeAssessmentResult> {
    return axios.get(`/api/assessment/employee/${employeeId}/result`)
      .then(response => new EmployeeAssessmentResult(response.data))
  }

  public static async getResultsAndAdherence(
    filter: AssessmentFilter,
    page: number,
    size: number,
  ): Promise<any> {
    return axios.get('/api/assessment/results', {
      params: {
        employees: filter.hasEmployees ? filter.employees.toString() : null,
        managers: filter.hasManagers ? filter.managers.toString() : null,
        resultCenters: filter.hasResultCenters ? filter.resultCenters.toString() : null,
        businessUnits: filter.hasBusinessUnits ? filter.businessUnits.toString() : null,
        assignments: filter.hasAssignments ? filter.assignments.toString() : null,
        indirectSubordinates: filter.indirectSubordinates,
        alreadySent: filter.alreadySent,
        active: filter.active,
        page: page - 1,
        size,
      },
    });
  }

  public static async getSimulationsByEmployeeId(
    employeeId: string,
  ): Promise<AssessmentSimulationSimple[]> {
    const { data } = await axios.get(`/api/assessment/simulations/${employeeId}`);
    return data.map((item: any) => new AssessmentSimulationSimple(item));
  }

  public static async getSimulationForm(
    assignmentId: string,
    levelId: string,
  ): Promise<Assessment> {
    return axios.get(`/api/assessment/form-template/simulation/${assignmentId}/${levelId}`)
      .then(({ data }: any) => new Assessment(data));
  }

  public static async getByAssessmentId(assessmentId: string): Promise<Assessment> {
    const { data } = await axios.get(`/api/assessment/form-template/assessment/${assessmentId}`);
    return new Assessment(data);
  }
}
